// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"9ff9eb9d","863":"9ff9eb9d"}[chunkId] + ".chunk.css";
};